import React from "react";
import Email from "../common/Email";
import queryString from "query-string";
import Modal from "../common/Modal";
import moment from "moment";
import SofIcon from "../common/Icons";
import WorkPacketFormPageComponent from "./WorkPacketFormPage";
import { AuthProvider } from "../../AuthProvider";
import { connect } from "react-redux";
import { emailApi } from "../../api/emailApi";
import { EmailWorkPacketsRequest } from "../../models/EmailWorkPacketsRequest";
import { FC } from "react";
import { FormEvent } from "react";
import { Fragment } from "react";
import { GeneralService } from "../../services/GeneralService";
import { last6Digits, toNominationNo } from "../../services/Helper";
import { Link } from "react-router-dom";
import { loadPdfDoc } from "../../services/PdfDocumentService";
import { DefaultButton, mergeStyleSets, PrimaryButton } from "@fluentui/react";
import { mergeStyles } from "@fluentui/react";
import { Option } from "../../models/Option";
import { OtherOption } from "../../models/EmailWorkPacketsRequest";
import { State } from "../../store";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  MODALITY,
  WorkPacket,
  WorkPacketLayout,
} from "../../models/WorkPacket";
import { WorkPacketForm } from "../../models/WorkPacket";
import { WorkPacketFormPage } from "../../models/WorkPacket";
import { WorkPacketService } from "../../services/WorkPacketService";
import { WorkPacketValue2 } from "../../models/WorkPacket";
import * as ActivityLogStore from "../../store/ActivityLogsStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as TruckNominationStore from "../../store/TruckNominationStore";
import * as WorkPacketStore from "../../store/WorkPacketStore";
import * as OfflineDataStore from "../../store/OfflineDataStore";
import clsx from "clsx";

type IProps = ActivityLogStore.ActivityLogsState &
  LineHandlingStore.LineHandlingState &
  TruckNominationStore.TruckNominationState &
  WorkPacketStore.WorkPacketState &
  OfflineDataStore.OfflineDataState &
  typeof OfflineDataStore.actionCreators &
  typeof WorkPacketStore.actionCreators;
const classes = mergeStyleSets({
  formContainer: { display: "flex", flexDirection: "column", height: "100%" },
  formHeader: {
    gap: 8,
    padding: 16,
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
  },
  formHeaderTitle: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "24px",
    letterSpacing: "0.005em",
    color: "#4C4C4C",
  },
  toolbarSeparator: {
    height: "40px",
    width: "1px",
    background: "#D8DFE6",
    margin: "0",
  },
  formFooter: {
    padding: 16,
    backgroundColor: "white",
    borderTop: "1px solid #c4c4c7",
    display: "flex",
    alignItems: "center",
  },
  formFooterInner: {
    maxWidth: 900,
    margin: "auto",
    // display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  primaryButton: {
    padding: "8px 36px",
    backgroundColor: "#009FDF",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2,
  },
  disabledButton: {
    padding: "8px 36px",
    backgroundColor: "#dddddd",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2,
  },
  modalEmail: {
    width: "100%",
    height: "100%",
    border: "0",
    boxShadow: "0 0 1em rgb(0 0 0 /.3)",
  },
});
const buttonIcon = mergeStyles({
  width: "48px",
    height: "48px",
    borderRadius: "50%",
  border: "1px solid var(--grey-200)",
  background: "var(--grey-050)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  selectors: {
    ":hover": {
      backgroundColor: "#EEEEEE",
      textDecoration: "none",
    },
  },
});

const WorkPacketFormComponent: FC<IProps> = (props: IProps) => {
  const { lineHandlingNo, workPacketId } = useParams() as any;
  const [isLoading, setIsLoading] = useState(false);
  const [isFormDisabled, setFormDisabled] = useState(false);
  const [displayName, setDisplayName] = useState("");
  const [documentId, setDocumentId] = useState<number>();
  const [workPacket, setWorkPacket] = useState<WorkPacket>();
  const [nominationNo, setNominationNo] = useState<string>();
  const [workPacketForm, setWorkPacketForm] = useState<WorkPacketForm>();
  const [activeWPPage, setActiveWPPage] = useState<WorkPacketFormPage>();
  const [generalService, setGeneralService] = useState<GeneralService>();
  const [submitButton, setSubmitButton] = useState("");
  const [pdfContentBlob, setPdfContentBlob] = useState<Blob>();
  const [pdfContent, setPdfContent] = useState<string>();
  const [emailAddresses, setEmailAddresses] = useState<readonly Option[]>([]);
  const [emailStatus, setEmailStatus] = useState<string>("default");
  const [modality, setModality] = useState<MODALITY>("MARINE");
  const [referer, setReferer] = useState<string>();
  const history = useHistory();
  const accountInfo = AuthProvider.getAccountInfo();

  const modalities = {
    MARINE: 0,
    TRUCK: 1,
    RAIL: 2,
  };

  const getBaseName = (name: string): string =>
    name.indexOf("#") >= 0 ? name.substring(0, name.indexOf("#")) : name;

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);

    const service = new WorkPacketService();
    const form = event.currentTarget;
    const formElements = form.elements as typeof form.elements & {
      usernameInput: { value: string };
    };
    const filtered = Array.from(formElements)
      .filter((f: any) => f.name && f.name.indexOf("--group-") < 0)
      .map((f: any) => ({
        name: f.name,
        value: f.ariaValueText ?? f.value,
        nominationNo: f.title.length > 0 ? f.title : undefined,
        validation: f?.dataset?.validation ? f.dataset.validation : "",
      }));

    const values = filtered.map(
      (f) =>
        ({
          ...f,
          type: activeWPPage?.formFields.find(
            (ff) => getBaseName(f.name) === ff.fieldName
          )?.valueType,
        } as WorkPacketValue2)
    );

    let isValidateSuccess = true;
    // Remove all elements with this
    var elementsToRemove = document.querySelectorAll(".validate-text-err");

    elementsToRemove.forEach(function (element) {
      element.parentNode?.removeChild(element);
    });

    values.forEach((value: WorkPacketValue2) => {
      if (value.validation) {
        let parsedCondition = JSON.parse(value.validation);
        parsedCondition.forEach((condition: any) => {
          if (!generalService?.checkConditions(condition.conditions, values)) {
            const inputElem = document.querySelector(
              `input[name=${value.name}]`
            );
            if (inputElem) {
              inputElem.setAttribute("data-class", "input-err");
              let span = document.createElement("span");
              span.textContent = condition.message;
              // span.setAttribute("data-class", "text-err");
              span.classList.add("validate-text-err");
              inputElem.parentNode?.appendChild(span);
            }
            isValidateSuccess = false;
          } else {
            const inputElem = document.querySelector(
              `input[name=${value.name}]`
            );
            if (inputElem) {
              inputElem.setAttribute("data-class", "");
            }
          }
        });
      }
    });

    if (!isValidateSuccess) {
      setIsLoading(false);
      return;
    }

    const docNameValue = values.find((f) => f.name === "__doc_name__");
    const hasOfflineData =
      props.offlineWorkPacketData &&
      props.offlineWorkPacketData.filter(
        (f) =>
          f.lineHandlingNo === lineHandlingNo && f.workPacketId === workPacketId
      ).length > 0;

    const offlineValuesData: any =
      props.offlineWorkPacketData &&
      props.offlineWorkPacketData.filter(
        (f) =>
          f.lineHandlingNo === lineHandlingNo && f.workPacketId === workPacketId
      )[0];

    let newValues;
    if (offlineValuesData && offlineValuesData.values) {
      const myArrayFiltered = offlineValuesData.values.filter((el: any) => {
        return !values.find((element: any) => {
          return element.name === el.name;
        });
      });
      newValues = values;
      newValues = myArrayFiltered.concat(values);
    } else {
      newValues = values;
    }
    var payload = {
      values: newValues,
      documentId,
      pageId: activeWPPage?.id,
      workPacketId,
      lineHandlingNo,
      nomination:
        nominationNo === "undefined" ? undefined : nominationNo?.toUpperCase(),
      name: docNameValue?.value ?? displayName,
      workPacketType: workPacket?.workPacketType,
    };
    try {
      const result = hasOfflineData
        ? await service.offlineExecuteAsync(payload, () =>
            props.insertOfflineWorkPacketData(payload)
          )
        : await service.executeActionAsync(payload, () =>
            props.insertOfflineWorkPacketData(payload)
          );

      let workPacketValues: any = [];
      if (result.values.length === 0 && result.values.length === 0) {
        values.forEach((v) => {
          workPacketValues.push({
            fieldName: v.name,
            fieldValue: v.value,
            valueType: v.type,
            documentId: documentId,
            nominationNo:
              nominationNo === "undefined"
                ? undefined
                : nominationNo?.toUpperCase(),
            createdBy:
              accountInfo?.account.accountIdentifier.toLocaleLowerCase(),
          });
        });
        props?.workPacketValues?.result?.forEach((v) => {
          const existing = workPacketValues.find(
            (f: any) => f.fieldName === v.fieldName
          );
          if (!existing) {
            workPacketValues.push(v);
          }
        });
      } else {
        workPacketValues = result.values;
      }

      let workPacketDocuments: any = [];
      if (result.documents.length === 0 && result.values.length === 0) {
        workPacketDocuments.push({
          workPacketId: parseInt(workPacketId),
          lineHandlingNo,
          name: payload.name,
        });
        props?.workPacketDocuments?.result?.forEach((v) => {
          const existing = workPacketDocuments.find(
            (f: any) =>
              parseInt(f.workPacketId) === v.workPacketId &&
              f.lineHandlingNo === v.lineHandlingNo
          );
          if (!existing) {
            workPacketDocuments.push(v);
          }
        });
      } else {
        workPacketDocuments = result.documents;

        if (documentId === undefined && workPacket?.workPacketType === 3) {
          setDocumentId(workPacketDocuments[0].id);
        }
      }

      props.setWPValues(workPacketValues);
      props.setWPDocuments(workPacketDocuments);
      props.insertWorkPacketDataLogs(
        lineHandlingNo,
        workPacketValues,
        workPacketDocuments
      );
      setIsLoading(false);
    } catch (ex) {
      const error = ex as Error;
      if (error) {
        console.log(error);
      }
    }

    if (
      workPacketForm &&
      activeWPPage?.order != workPacketForm.pages.length &&
      submitButton === "Next"
    ) {
      var nextPage = workPacketForm.pages.find(
        (x) => x.order === activeWPPage!.order + 1
      );

      if (nextPage !== undefined) {
        setActiveWPPage(nextPage);
      }
    }

    if (workPacketForm && activeWPPage?.order != 1 && submitButton === "Back") {
      var prevPage = workPacketForm.pages.find(
        (x) => x.order === activeWPPage!.order - 1
      );

      if (prevPage !== undefined) {
        setActiveWPPage(prevPage);
      }
    }
  };

  const onPreview = () => {
    if (workPacket) {
      var params = "";
      if (workPacket.level === 2) {
        params = "?nomination=" + nominationNo;
      }
      if (documentId) {
        params += (params.length > 0 ? "&" : "?") + "documentId=" + documentId;
      }
      history.push(
        `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/work-packet/${
          workPacket.id
        }/preview${params}`
      );
    }
  };

  const initialLoad = () => {
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const nominationno = q.nomination as string | undefined;
    setNominationNo(nominationno);

    const documentid = q.documentid as string | undefined;
    if (documentid) setDocumentId(parseInt(documentid));

    const _referer = q.referer as string | undefined;
    setReferer(_referer);

    const _modality =
      history.location.pathname.indexOf("marine") >= 0
        ? "MARINE"
        : history.location.pathname.indexOf("truck") >= 0
        ? "TRUCK"
        : "RAIL";
    setModality(_modality);

    let _displayName = "";
    if (workPacketId && props.workPackets.result) {
      const workpacket = props.workPackets.result.find(
        (f) => f.id === parseInt(workPacketId, 10)
      );
      if (workpacket) {
        setWorkPacket(workpacket);
        _displayName = workpacket.name;
        if (workpacket.forms.length > 0) {
          setWorkPacketForm(workpacket.forms[0]);
          setActiveWPPage(workpacket.forms[0].pages[0]);
        } else {
          if (_modality === "TRUCK") {
            history.push(
              `/truck/${lineHandlingNo}/work-packet/${workpacket.id}/preview`
            );
          } else if (_modality === "RAIL") {
            history.push(
              `/rail/${lineHandlingNo}/work-packet/${workpacket.id}/preview`
            );
          } else {
            history.push(
              `/marine/${lineHandlingNo}/work-packet/${workpacket.id}/preview${
                workpacket.level === 2 ? `?nomination=${nominationno}` : ""
              }`
            );
          }
        }

        if (workpacket.workPacketType === 3) {
          let count: any = 0;

          switch (workpacket?.id) {
            case 28:
              count = props.workPacketDocuments.result?.filter(
                (f) =>
                  f.workPacketId === workpacket.id &&
                  f.name.includes("Drum Handling")
              ).length;
              break;
            default:
              count = props.workPacketDocuments.result?.filter(
                (f) => f.workPacketId === workpacket.id
              ).length;
              break;
          }

          if (count && count > 0) {
            _displayName += ` (${count + 1})`;
          }
        }
      }
    }

    if (documentId && props.workPacketDocuments.result) {
      const wpDocument = props.workPacketDocuments.result.find(
        (f) => f.id === documentId
      );
      setNominationNo(wpDocument?.nominationNo);
    }

    let nomination;
    if (_modality === "MARINE") {
      nomination =
        nominationno && props.lineHandling.result
          ? props.lineHandling.result?.nominations.find(
              (f) => f.nominationNo.toUpperCase() === nominationno.toUpperCase()
            )
          : undefined;
    } else if (_modality === "TRUCK" || _modality === "RAIL") {
      nomination = props.truckNomination.result;
    }
    const genService = new GeneralService(
      props.lineHandling.result,
      nomination,
      props.activityLogs.result,
      props.workPacketValues.result
    );
    if (nomination) {
      _displayName += ` (${nomination.product} - ${toNominationNo(
        nomination.nominationNo
      )})`;
    }

    if (documentid) {
      const docs = props.workPacketDocuments.result?.find(
        (f) => f.id === parseInt(documentid, 10)
      );
      if (docs) {
        _displayName = docs.name;
      }
    }

    setDisplayName(_displayName);
    setGeneralService(genService);
  };

  useEffect(() => {
    if (props.workPackets.result && props.workPackets.result?.length > 0) {
      initialLoad();
    }
  }, [props.workPackets]);

  useEffect(() => {
    if (history.location.pathname.indexOf("marine") >= 0) {
      setModality("MARINE");
    } else if (history.location.pathname.indexOf("truck") >= 0) {
      setModality("TRUCK");
    } else if (history.location.pathname.indexOf("rail") >= 0) {
      setModality("RAIL");
    }
    props.getWPValues(lineHandlingNo, () => {
      if (props.workPackets.result && props.workPackets.result.length > 0) {
        initialLoad();
      } else {
        props.getAllWorkPackets();
      }
    });
  }, []);

  const loadPdf = async (layout: WorkPacketLayout) => {
    const pdfDoc = await loadPdfDoc(
      layout.pdfFile,
      lineHandlingNo,
      nominationNo === "undefined" ? undefined : nominationNo,
      documentId,
      props.lineHandling,
      props.workPacketValues
    );
    if (pdfDoc) {
      const pdfBytes = await pdfDoc.save({});
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      setPdfContentBlob(blob);
      const docUrl = URL.createObjectURL(blob);
      setPdfContent(docUrl);
    }
  };

  useEffect(() => {
    if (workPacket) {
      const layout = workPacket.layouts[0];
      loadPdf(layout);
    }
  }, [workPacket]);

  useEffect(() => {
    let linehandlingStatus: number | undefined =
      props?.lineHandling?.result?.status;
    if (linehandlingStatus && linehandlingStatus >= 4) {
      setFormDisabled(true);
    }
  }, [props.lineHandling]);

  const blobToBase64 = (blob: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  const closeEmailModal = () => {
    const modal = document.getElementById(
      "sendemail-modal"
    ) as HTMLDialogElement;
    modal.close();
  };

  const sendEmailModal = async () => {
    setEmailAddresses([]);
    setEmailStatus("default");

    //load the pdf first before showing the modal
    if (workPacket) {
      const layout = workPacket.layouts[0];
      loadPdf(layout);
    }

    const modal = document.getElementById(
      "sendemail-modal"
    ) as HTMLDialogElement;
    modal.showModal();
  };

  const sendEmail = async () => {
    if (pdfContent === undefined) return;

    setEmailStatus("sending");

    const result = (await blobToBase64(pdfContentBlob)) as string;

    const array = result?.split(",");
    const base64 = array.length > 0 ? array[1] : "";

    const workPackets = [workPacket?.name];

    const currentDate = moment().format("YYYYMMDD-HHmm");

    let otherOptions: OtherOption[] = [];

    if (modality === "TRUCK" || modality === "RAIL") {
      otherOptions = [{ key: "nominationNo", value: lineHandlingNo }];
    }

    console.log(nominationNo);
    const attachmentRequest = {
      recipients: emailAddresses.map((a: { value: string }) => a.value),
      vesselName: props.lineHandling.result?.vesselName,
      attachments: [
        {
          content: base64,
          fileName: `workpackets-${currentDate}.pdf`,
          mimeType: "application/pdf",
        },
      ],
      workpackets: workPackets,
      status: props.lineHandling.result?.status,
      modality: modalities[modality],
      otherOptions: otherOptions,
    } as EmailWorkPacketsRequest;

    const emailResponse = await emailApi.sendEmailWorkPacketsAsync(
      attachmentRequest
    );

    if (emailResponse.emailStatus) {
      setEmailStatus("success");

      setTimeout(function () {
        const modal = document.getElementById(
          "sendemail-modal"
        ) as HTMLDialogElement;
        modal.close();
      }, 3000);
    } else {
      setEmailStatus("error");
    }
  };

  const onClose = () => {
    if (workPacket) {
      if (history.location.state?.fromGroupPage) {
        history.push(history.location.state?.prevPath);
      } else {
        history.push(
          workPacket.workPacketType === 1
            ? `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/work-packets`
            : `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/services`
        );
      }
    }
  };

  return (
    <Fragment>
      {workPacket && (
        <form
          id={`dwp-form`}
          name={`dwp-form-${workPacket.id}`}
          className={classes.formContainer}
          onSubmit={onSubmit}
        >
          <div className={classes.formHeader}>
            {referer && (
              <Link className={buttonIcon} to={referer}>
                <SofIcon iconname="Back" />
              </Link>
            )}
            <span id="form-title" className={classes.formHeaderTitle}>
              {displayName}
            </span>
            <div style={{ flexGrow: 1 }}></div>
            <button
              id="btn-send"
              type="button"
              className={buttonIcon}
              onClick={sendEmailModal}
              disabled={
                workPacket.workPacketType === 3 && documentId === undefined
              }
            >
              <SofIcon iconname="Mail" />
            </button>
            <button
              id="btn-print"
              type="button"
              className={buttonIcon}
              onClick={onPreview}
              disabled={
                workPacket.workPacketType === 3 && documentId === undefined
              }
            >
              <SofIcon iconname="Print" />
            </button>
            <div className={classes.toolbarSeparator}></div>
            <button
              id="btn-close"
              type="button"
              className={buttonIcon}
              onClick={() => onClose()}
            >
              <SofIcon iconname="CloseIcon" />
            </button>
          </div>
          <div
            id={`dwp-${workPacket.id}`}
            className="custom-scroll"
            style={{ padding: 16, flexGrow: 1, overflow: "auto" }}
          >
            {activeWPPage && (
              <WorkPacketFormPageComponent
                lineHandlingNo={lineHandlingNo}
                documentId={documentId}
                nominationNo={
                  nominationNo === "undefined"
                    ? undefined
                    : nominationNo?.toUpperCase()
                }
                workPacketPage={activeWPPage}
                disabled={
                  // props?.lineHandling?.result?.status === 2 ||
                  props?.lineHandling?.result?.status === 4 ||
                  // props.truckNomination?.result?.status === 2 ||
                  props.truckNomination?.result?.status === 4 ||
                  isLoading
                }
                generalService={generalService}
                values={props.workPacketValues.result ?? []}
              ></WorkPacketFormPageComponent>
            )}
          </div>
          <div className={classes.formFooter}>
            <div className={classes.formFooterInner}>
                          {workPacketForm && activeWPPage?.order != 1 && (
                              <PrimaryButton
                    type="submit"        
                    onClick={() => setSubmitButton("Back")}
                    text="Back"
                     className={
                        isLoading ? classes.disabledButton : classes.primaryButton
                     }
                          />
                //<button
                //  type="submit"
                //  onClick={() => setSubmitButton("Back")}
                //  disabled={
                //    props?.lineHandling?.result?.status === 2 ||
                //    props?.lineHandling?.result?.status === 4 ||
                //    props.truckNomination?.result?.status === 2 ||
                //    props.truckNomination?.result?.status === 4 ||
                //    isLoading
                //  }
                //  className={
                //    isLoading ? classes.disabledButton : classes.primaryButton
                //  }
                //>
                //  Back
                //</button>
                          )}
                          <PrimaryButton
                              type="submit" 
                              onClick={() => setSubmitButton("Next")}
                              style={{ float: "right" }}
                              disabled={
                                  // props?.lineHandling?.result?.status === 2 ||
                                  props?.lineHandling?.result?.status === 4 ||
                                  // props.truckNomination?.result?.status === 2 ||
                                  props.truckNomination?.result?.status === 4 ||
                                  isLoading
                              }
                              text={workPacketForm &&
                                  activeWPPage?.order != workPacketForm.pages.length
                                  ? "Next"
                                  : "Save"}
                          />
              {/*<button*/}
              {/*  type="submit"*/}
              {/*  style={{ float: "right" }}*/}
              {/*  onClick={() => setSubmitButton("Next")}*/}
              {/*  disabled={*/}
              {/*    props?.lineHandling?.result?.status === 2 ||*/}
              {/*    props?.lineHandling?.result?.status === 4 ||*/}
              {/*    props.truckNomination?.result?.status === 2 ||*/}
              {/*    props.truckNomination?.result?.status === 4 ||*/}
              {/*    isLoading*/}
              {/*  }*/}
              {/*                className={*/}
              {/*                    clsx(isLoading ? classes.disabledButton : classes.primaryButton, "ms-Button--primary")*/}
              {/*  }*/}
              {/*>*/}
              {/*  {workPacketForm &&*/}
              {/*  activeWPPage?.order != workPacketForm.pages.length*/}
              {/*    ? "Next"*/}
              {/*    : "Save"}*/}
              {/*</button>*/}
            </div>
          </div>
          <div>
            <Modal
              id="sendemail-modal"
              title="Send Work Packets"
              className={classes.modalEmail}
              showModalHeader={false}
            >
              <Email
                id="email"
                pdfSrc={pdfContent}
                emailStatus={emailStatus}
                emailAddresses={emailAddresses}
                setEmailAddresses={setEmailAddresses}
                closeEmailModal={closeEmailModal}
                sendEmail={sendEmail}
                workPacketDisplayName={workPacket?.name}
              ></Email>
            </Modal>
          </div>
        </form>
      )}
    </Fragment>
  );
};
export default connect(
  (state: State) => ({
    ...state.authentication,
    ...state.activityLogs,
    ...state.lineHandling,
    ...state.truckNomination,
    ...state.workPacket,
    ...state.offlineData,
  }),
  {
    ...WorkPacketStore.actionCreators,
    ...OfflineDataStore.actionCreators,
  }
)(WorkPacketFormComponent as any);
